import { Injectable } from '@angular/core';

import { TooltipDirective } from '../directive/tooltip.directive';

/**
 * TooltipService makes sure that if there are multiple tooltips in one view, only one of them is open at the time
 */
@Injectable({
  providedIn: 'root',
})
export class TooltipService {
  private openTooltip: TooltipDirective = null;

  open(tooltip: TooltipDirective): void {
    if (this.openTooltip) {
      this.openTooltip.destroyTooltip();
    }
    this.openTooltip = tooltip;
  }

  close(shouldFocusOnHost?: boolean): void {
    if (this.openTooltip) {
      this.openTooltip.destroyTooltip(shouldFocusOnHost);
    }

    this.openTooltip = null;
  }
}
